import { Controller } from "@hotwired/stimulus"

// Article share group: copies the page link and toggles a menu of share targets.
export default class extends Controller {
  static targets = ["copyLabel", "toggle", "menu"]
  static values = { url: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch (_error) {
      return
    }
    this.copyLabelTarget.textContent = "Copied"
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => { this.copyLabelTarget.textContent = "Copy link" }, 1800)
  }

  toggle() {
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.toggleTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.menuTarget.hidden = true
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }
}
